<ng-container *transloco="let t; read: 'time-entries'">
<h1 class="mbm">Zeiterfassung</h1>

<kendo-tabstrip *ngIf="ready">
  <kendo-tabstrip-tab [title]="t('my-time.title')" [selected]="true">
    <ng-template kendoTabContent>
      <app-my-time></app-my-time>
    </ng-template>
  </kendo-tabstrip-tab>

  <!-- Reports across other employees: needs the permission and somebody within reach. -->
  <kendo-tabstrip-tab *ngIf="canViewAllReports" [title]="t('allReports.title')">
    <ng-template kendoTabContent>
      <app-time-report></app-time-report>
    </ng-template>
  </kendo-tabstrip-tab>

  <!-- Work time violations of the employees within reach; only while at least one tenant control is on. -->
  <kendo-tabstrip-tab *ngIf="canViewAllReports && hasWorkTimeControls" [title]="t('workTimeViolations.title')">
    <ng-template kendoTabContent>
      <app-work-time-violations></app-work-time-violations>
    </ng-template>
  </kendo-tabstrip-tab>

  <!-- Company-wide numbers, so the tab needs more than the page's basic permission. -->
  <kendo-tabstrip-tab *permissionIf="'Permissions.TimeEntries.Search'" [title]="t('evaluation.title')">
    <ng-template kendoTabContent>
      <app-time-evaluation></app-time-evaluation>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>

</ng-container>
